export default {
    '1': '商品の誤注文',
    '2': '注文の重複',
    '3': '受け取り不可',
    '4': 'その他の理由',
    '充值金额不能小于1': '形式エラー：チャージ金額は1未満にできません（小数2桁を含む）',
    '-连接已建立-': '-接続が確立されました-',
    ',才可提币': '、で出金できます',
    '[code]值错误': '[code] の値が不正です',
    '[symbol]参数为空': '[symbol] パラメータが空です',
    homeDownloadtips41: '加盟店アプリ',
    '不能为空': '空にできません',
    '不在交易时段': '取引時間外です',
    '不在可提现时间内': '出金可能時間外です',
    '参数错误': 'パラメータエラー',
    '参数异常，消息获取失败': 'パラメータ異常、メッセージの取得に失敗しました',
    '操作成功': '操作に成功しました',
    '操作类型不能小于0': '操作タイプは0未満にできません',
    '操作类型不是整数': '操作タイプが整数ではありません',
    '操作类型为空': '操作タイプが空です',
    '产品不存在': '商品が存在しません',
    '产品剩余数量不足': '商品の残り数量が不足しています',
    '承兑商不存在': '取扱業者が存在しません',
    '程序错误': 'プログラムエラー',
    '持有币种不足': '保有通貨が不足しています',
    '充值价值不得大于最大限额': 'チャージ額は上限を超えてはいけません',
    '充值价值不得小于最小限额': 'チャージ額は下限を下回ってはいけません',
    '充值链错误': 'チャージチェーンが不正です',
    '充值数量不能小于等于0': 'チャージ数量は0以下にできません',
    '存在不同杠杆的持仓单': '異なるレバレッジの建玉が存在します',
    '存在重复的角色名称': '重複したロール名が存在します',
    '大于最大采购数量': '最大購入数量を超えています',
    '代理层级错误': '代理階層が不正です',
    '待付款的订单无法放行': '未払いの注文はリリースできません',
    '当前地址格式错误': '現在のアドレス形式が不正です',
    '当前订单不为待付款状态，无法取消': '注文が支払い待ち状態ではないためキャンセルできません',
    '当前还需交易': '現在さらに取引が必要です',
    '当日才可申购': '当日のみ申込可能です',
    '当日可提现次数不足': '当日の出金回数が不足しています',
    '登陆密码不符合设定': 'ログインパスワードが設定要件を満たしていません',
    '登陆密码长度不符合设定': 'ログインパスワードの長さが設定要件を満たしていません',
    '登录过期，请重新登录': 'セッションの有効期限が切れました。再度ログインしてください',
    '登录密码必须6-12位': 'ログインパスワードは6〜12文字である必要があります',
    '登录密码不能为空': 'ログインパスワードは空にできません',
    '登录失败': 'ログインに失敗しました',
    '电话号码已绑定': '電話番号は既に連携済みです',
    '电话号码已绑定其他用户': '電話番号は既に他のユーザーに連携されています',
    '订单不存在': '注文が存在しません',
    '订单已取消': '注文はキャンセルされました',
    '订单已取消，无法放行': '注文がキャンセルされたためリリースできません',
    '订单已完成，无法放行': '注文が完了しているためリリースできません',
    '发现新版本，请升级到最新版本': '新しいバージョンがあります。最新版に更新してください',
    '服务器错误': 'サーバーエラー',
    '服务器错误(500)': 'サーバーエラー (500)',
    '该产品未上架': 'この商品は未掲載です',
    '该产品已上市，无法购买': 'この商品は既に上場済みで購入できません',
    '该订单已取消': 'この注文はキャンセルされました',
    '该广告剩余数量不足': 'この広告の残り数量が不足しています',
    '该基金尚未开放购买': 'このファンドはまだ購入できません',
    '该基金尚已封闭': 'このファンドは既にクローズされています',
    '该邮箱已被订阅': 'このメールは既に登録されています',
    '格式有误:充值金额不能小于1(包含俩位小数)': '形式エラー：チャージ金額は1未満にできません（小数2桁を含む）',
    '跟单倍数输入错误': 'コピートレード倍率の入力が不正です',
    '跟单参数输入错误': 'コピートレードパラメータの入力が不正です',
    '更新提醒': '更新のお知らせ',
    '工作地址不能为空': '勤務先住所は空にできません',
    '购买矿机时间不得低于托管订单剩余时间': 'マイニングマシンの購入期間は、ホスティング注文の残り時間を下回ってはいけません',
    '广告不存在': '広告が存在しません',
    '广告已下架': '広告は取り下げられました',
    '基金剩余购买金额不足': 'ファンドの残り購入可能額が不足しています',
    '家庭地址不能为空': '自宅住所は空にできません',
    '交易员不存在': 'トレーダーが存在しません',
    '交易员不能跟随自己': 'トレーダーは自分自身をフォローできません',
    '交易员跟随人数已满': 'トレーダーのフォロワー数が上限に達しました',
    '交易员未开启带单': 'トレーダーはコピートレードを有効にしていません',
    '交易员无法跟随另一个交易员': 'トレーダーは他のトレーダーをフォローできません',
    '角色被用户关联，不可删除': 'ロールはユーザーに関連付けられているため削除できません',
    '角色不存在': 'ロールが存在しません',
    '金额不在购买区间': '金額が購入範囲外です',
    '金额错误': '金額エラー',
    '旧密码不能为空': '旧パスワードは空にできません',
    '旧密码不正确': '旧パスワードが正しくありません',
    '可平仓合约张数不足': '決済可能な契約数が不足しています',
    '矿机不存在': 'マイニングマシンが存在しません',
    '矿机未解锁，无法购买': 'マイニングマシンがロック解除されていないため購入できません',
    '历史基金无法购买': '過去のファンドは購入できません',
    '连续输入错误三次，请3分钟后再试': '3回連続で誤入力しました。3分後に再試行してください',
    '领取成功': '受け取りに成功しました',
    '买入金额需要在区间内': '購入金額は範囲内である必要があります',
    '卖方无法取消该订单': '売り手はこの注文をキャンセルできません',
    '没有找到用户': 'ユーザーが見つかりません',
    verificationCode: '認証コード',
    pleaseEnterVerificationCode: '認証コードを入力してください',
    pleaseEnterUsername: 'ユーザー名を入力してください',
    username: 'ユーザー名',
    getVerificationCode: 'コードを取得',
    tryAgainLater: '秒後に再試行',
    '密码必须6-12位': 'パスワードは6〜12文字である必要があります',
    '密码不能为空': 'パスワードは空にできません',
    '密码不正确': 'パスワードが正しくありません',
    '您当前可分配额度不足': '現在割り当て可能な額度が不足しています',
    '您没有符合条件的收款方式': '条件に合う受取方法がありません',
    '您已存在订单': '既に注文があります',
    '您已购买过体验矿机,不得重复购买': '体験用マイニングマシンを既に購入済みのため、再購入できません',
    '亲属地址不能为空': '親族の住所は空にできません',
    '亲属电话不能为空': '親族の電話番号は空にできません',
    '亲属关系不能为空': '続柄は空にできません',
    '亲属姓名不能为空': '親族の氏名は空にできません',
    '请检查网络连接': 'ネットワーク接続を確認してください',
    '请切换其他语言后查看': '別の言語に切り替えてご覧ください',
    '请上传图片': '画像をアップロードしてください',
    '请稍后再试': '後でもう一度お試しください',
    '请稍后重试': '後でもう一度お試しください',
    '请输入充值币种': 'チャージ通貨を入力してください',
    '请输入内容': '内容を入力してください',
    '请输入搜索关键字': '検索キーワードを入力してください',
    '请输入正确的货币数量': '正しい通貨数量を入力してください',
    '请输入正确的金额': '正しい金額を入力してください',
    '请输入正确的数量': '正しい数量を入力してください',
    '请输入正确的质押金额': '正しいステーキング金額を入力してください',
    '请输入正确的质押天数': '正しいステーキング日数を入力してください',
    '请填写正确的电话号码': '正しい電話番号を入力してください',
    '请填写正确的验证码': '正しい認証コードを入力してください',
    '请填写正确的邮箱地址': '正しいメールアドレスを入力してください',
    '请先绑定谷歌验证器': '先にGoogle Authenticatorを連携してください',
    '请先添加收款方式': '先に受取方法を追加してください',
    '请先通过高级认证': '先に上級認証を完了してください',
    '请选择买卖方式': '売買方法を選択してください',
    '请选择正确的币种': '正しい通貨を選択してください',
    '请重新登录': '再度ログインしてください',
    '渠道未开通': 'チャネルが開通していません',
    '取消': 'キャンセル',
    '确认': '確認',
    '申购数量错误': '申込数量が不正です',
    '申请成功': '申請に成功しました',
    '身份证已实名过!': '身分証は既に本人確認済みです！',
    '审核已通过': '審査に通過しました',
    '审核中': '審査中',
    '实名认证未通过，无法进行高级认证': '本人確認が未通過のため、上級認証を行えません',
    '收款方输入错误': '受取人の入力が不正です',
    '授权状态未成功': '認可ステータスが成功していません',
    '赎回状态异常': '償還ステータスが異常です',
    '所选汇率不存在': '選択した為替レートが存在しません',
    '提币数量不能小于等于0': '出金数量は0以下にできません',
    '提交失败': '送信に失敗しました',
    '提交失败，当前有未处理订单': '送信に失敗しました。未処理の注文があります',
    '提示': 'お知らせ',
    '提现不得大于限额': '出金は上限を超えてはいけません',
    '提现不得小于限额': '出金は下限を下回ってはいけません',
    '图片不得大于10M': '画像は10MBを超えてはいけません',
    '图片不得大于2M': '画像は2MBを超えてはいけません',
    '图片大小不能超过2M！': '画像サイズは2MBを超えられません！',
    '图片上传失败': '画像のアップロードに失敗しました',
    '推荐码不正确': '紹介コードが正しくありません',
    '推荐人无权限推荐': '紹介者に紹介権限がありません',
    '推荐商品': 'おすすめ商品',
    '委托数量(张)必填': '注文数量（枚）は必須です',
    '委托数量(张)不能小于等于0': '注文数量（枚）は0以下にできません',
    '未绑定谷歌验证器': 'Google Authenticatorが未連携です',
    '未绑定手机号': '電話番号が未連携です',
    '未绑定邮箱': 'メールが未連携です',
    '未发现授权记录': '認可記録が見つかりません',
    '未实名认证，是否认证？': '本人確認が未完了です。認証しますか？',
    '未授权访问': '不正なアクセスです',
    '未找到符合条件的匹配订单': '条件に合う注文が見つかりません',
    '未找到匹配的收益记录': '一致する収益記録が見つかりません',
    myComment: 'マイレビュー',
    myPoint: 'マイポイント',
    accountInfo: 'アカウント情報',
    myBalance: 'マイ残高',
    myCoupon: 'マイクーポン',
    unused: '未使用',
    used: '使用済み',
    expired: '期限切れ',
    expires: '有効期限',
    minSpend: '以上',
    availableBalance: '利用可能残高',
    personalDeposit: '残高',
    useDepositBalance: '残高で割引',
    depositDeduct: '残高割引',
    useMaxDeposit: '全額割引',
    balanceHistory: '残高履歴',
    recordCount: '全 {count} 件',
    depositType: '取引タイプ',
    balanceAfter: '残高',
    depositTypeRecharge: '残高チャージ',
    depositTypeAdjustment: '残高調整',
    depositTypeOrderPayment: '注文支払い',
    depositTypeOrderRefunds: '注文返金',
    depositTypeDistributionCommission: '販売手数料',
    depositTypeDistributionWithdrawal: '販売出金',
    depositTypeOther: 'その他',
    income: '収入',
    expense: '支出',
    description: '説明',
    myFootprint: '閲覧履歴',
    '我的购物车': 'マイカート',
    '无权限': '権限がありません',
    '无效的UID': '無効なUID',
    '系统参数错误': 'システムパラメータエラー',
    '系统存在相同[系统登录名]！': 'システムに同じ[ログイン名]が存在します！',
    '系统错误，请稍后重试': 'システムエラー、後でもう一度お試しください',
    '下单不能小于最小金额限制': '注文は最低金額を下回ってはいけません',
    '校验IP不合法': '検証IPが不正です',
    '新密码不能为空': '新しいパスワードは空にできません',
    '新密码不一致': '新しいパスワードが一致しません',
    '新密码确认不能为空': '新しいパスワードの確認は空にできません',
    '行情获取异常，稍后再试': '相場の取得に失敗しました。後で再試行してください',
    '验证类型不能为空': '認証タイプは空にできません',
    '验证码不能为空': '認証コードは空にできません',
    '验证码不正确': '認証コードが正しくありません',
    '验证码错误': '認証コードが不正です',
    '页码不能小于等于0': 'ページ番号は0以下にできません',
    '页码不是整数': 'ページ番号が整数ではありません',
    '已领取': '受け取り済み',
    '用户不存在': 'ユーザーが存在しません',
    '用户名必须由数字和英文字母组成': 'ユーザー名は数字と英字のみで構成する必要があります',
    '用户名不存在': 'ユーザー名が存在しません',
    '用户名不符合设定': 'ユーザー名が要件を満たしていません',
    '用户名不能为空': 'ユーザー名は空にできません',
    '用户名参数为空': 'ユーザー名パラメータが空です',
    '用户名重复': 'ユーザー名が重複しています',
    '用户剩余数量不足': 'ユーザーの残り数量が不足しています',
    '用户已跟随交易员': 'ユーザーは既にトレーダーをフォローしています',
    '邮箱已绑定': 'メールは既に連携済みです',
    '邮箱已绑定其他用户': 'メールは既に他のユーザーに連携されています',
    '余额不足': '残高不足',
    shop_order_insufficientBalance: 'アカウント残高が不足しています',
    '帐户异常需要进行C3认证，请联系在线客服。': 'アカウントに異常があり、C3認証が必要です。オンラインサポートにお問い合わせください。',
    '找不到用户': 'ユーザーが見つかりません',
    flashSale: 'タイムセール',
    groupBuy: '共同購入',
    groupBuying: 'グループ購入',
    couponCenter: 'クーポンセンター',
    pointMall: 'ポイントモール',
    liveList: 'ライブ配信',
    endsIn: '終了まで',
    soldOut: '販売済み',
    people: '人',
    joined: '参加済み',
    startGroup: '共同購入を開始',
    getCoupon: '受け取る',
    '直线关系，不能修改推荐': '直系関係のため、紹介を変更できません',
    '重复提交': '重複送信',
    '转账币种不能为空': '送金通貨は空にできません',
    '转账数量不能小于等于0': '送金数量は0以下にできません',
    '状态不能小于0': 'ステータスは0未満にできません',
    '状态不是整数': 'ステータスが整数ではありません',
    '资金密码必须6-12位': '資金パスワードは6〜12文字である必要があります',
    '资金密码不符合设定': '資金パスワードが要件を満たしていません',
    '资金密码不能为空': '資金パスワードは空にできません',
    '资金密码错误': '資金パスワードが不正です',
    '资金密码长度不符合设定': '資金パスワードの長さが要件を満たしていません',
    'UID不能为空': 'UIDは空にできません',
    required: 'この項目は必須です',
    nickname: 'ニックネーム',
    enterNickname: 'ニックネームを入力してください',
    gender: '性別',
    male: '男性',
    female: '女性',
    secret: '非公開',
    birthday: '誕生日',
    selectDate: '日付を選択',
    cancelOrderMap: {
        0: "私はそれをしたくありません。",
        1: "商品を置き忘れた",
        2: "重複注文",
        3: "受信に失敗しました",
        4: "その他の理由",
    },
    "电商批发商场": "電子商取引卸売市場",
    "请输入完整的支付密码!" : "完全な支払いパスワードを入力してください！",
    "用户未发表评论": "ユーザーはコメントしていません",
    "订单": "注文",
    "下单成功，等待付款": "注文は正常に行われ、支払いを待っています",
    "下单成功，付款成功": "注文が正常に行われ、支払いが完了しました",
    "已发货，正在运输中": "出荷済み、輸送中",
    "订单已取消，原因:手动发起取消订单": "注文はキャンセルされました。 理由: 注文を手動でキャンセルします。",
    "订单已取消，原因:超时自动取消订单": "注文はキャンセルされました。 理由: 注文はタイムアウト時に自動的にキャンセルされます。",
    "商家已确认，已进入备货状态": "商人が確認され、在庫状態に入りました。",
    "系统发货成功": "システム配信成功",
    "订单已签收": "ご注文承りました",
    "发起退款申请": "払い戻しリクエストを開始する",
    "退款成功": "払い戻しが成功しました",
    "退款失败": "払い戻しに失敗しました",
    "订单退款成功": "注文の払い戻しが成功しました",
    "订单退款失败": "注文の払い戻しに失敗しました",
    "系统默认好评": "システムはデフォルトで好意的なレビューを表示します",
    "请输入关键字搜索": "キーワードを入力して検索してください",
    "猜你喜欢": "あなたはそれが好きだと思います",
    "订单已完成": "注文が完了しました",
    "热销推荐": "売れ筋のおすすめ",
    "头像选择": "アバターの選択",
    "修改头像": "変更する",
    "获取验证码": "確認コードを取得する",
    "请输入验证码": "確認コードを入力してください",
    "验证码": "確認コード",
    "发送": "送信",
    "已发送，请注意查收": "送信しました。 注意してください",
    subOrder: "注文を送信",
    "mailboxCheck": "正しいメールアドレスを入力してください",
    "switchLang": "表示するには別の言語に切り替えてください",
    "myCart": "私のショッピングカート",
    "notQua": "資格条件を満たしていません。",
    "noSmaller": "適用された金額は以下にすることはできません",
    "nomax": "お申し込み上限額を超えることはできません",
    "evaluationUploading": "まだ写真をアップロードしています。 後でもう一度やり直してください",
    "evaluateInput": "写真で振り返る",
    "moneyOrderStatus": "注文の状況",
    "coinBlock": "通貨協定",
    "dealing": "処理中",
    "dealSuccess": "成功",
    "dealFail": "失敗",
    "payCertificate": "支払証明書",
    "handleFee": "サービス料",
    "highOpinion": "良いレビュー",
    "mediumOpinion": "中程度のレビュー",
    "lowOpinion": "悪いレビュー",
    "hasImage": "写真付き",
    "rechargeMethod": "充電モード",
    "scanAndDown": "QRコードをスキャン アプリをダウンロード",
    "receivedAddress": "受取先",
    "ActualLedger": "実際の領収書",
    "view": "意見",
    "withdrawNum": "出金枚数",
    "rechargeNum": "充電量",
    "date": "日にち",
    "walletHistory": "ウォレット履歴",
    "accountBalance": "勘定残高",
    "accountReview": "口座[アカウント]状況",
    "rated": "審査",
    "receiver": "レシーバー",
    "orderStatus": "スターテス",
    "orderTime": "時間",
    "tax": "課税",
    "discount": "割引",
    "productInfo": "商品情報",
    "paramError": "パラメータエラー",
    "orderInfo": "注文情報",
    "rebuy": "もう1つ注文",
    "pleaseCorrectAddress": "正しい現金引き出しアドレスを入力してください",
    "pleaseInputCorrectNumber": "0 より大きい数値を入力してください",
    "vcodePass": "検証に合格しました！",
    "vcodeFail": "認証に失敗しました。もう一度やり直してください",
    "uploading": "アップロード中...",
    "uploadSuccess": "アップロード成功",
    "uploadError": "アップロードに失敗しました。 もう一度お試しください",
    "registerSuccess": "登録成功",
    "pleaseSetMobileNumber": "電話番号を設定してください",
    "unSelectedProduct": "製品を選択していません",
    "loginSuccess": "ログイン成功",
    "pleaseSetAreaCode": "国名と市外局番を入力して検索",
    "login": "ログイン",
    "register": "登録",
    "logout": "出口",
    "noData": "何もデータが見つかりませんでした",
    "search": "検索",
    "historySearch": "履歴検索",
    "empty": "空",
    "home": "ホームページ",
    "favorableRate": "良いレビュー率",
    "classification": "カテゴリー",
    "searchTips": "ソース検索/製品/サプライヤー/注文",
    "dailyNewArrival": "毎日の新製品リスト",
    "more": "もっと",
    "recommend": "おすすめ",
    "recommendedProducts": "おすすめ商品",
    "recommendedStore": "おすすめ店",
    "buyNow": "今すぐ購入",
    "addCart": "ショッピングカートに入れる",
    "complex": "統合",
    "price": "価格",
    "retailPrice": "小売価格",
    "originPrice": "元値",
    "service": "顧客サービス",
    "collect": "お気に入り",
    "sold": "販売量",
    "pageviews": "閲覧量",
    "quantity": "量",
    "freight": "貨物",
    "shipping": "運送",
    "ship": "ボート",
    "buyTips": "ご注文後24時間以内に発送。 以下の注文は物流管理下にあり、発送が遅れる場合があります。 物流情報に注意を払うか、カスタマーサービスに連絡してください。",
    "totalPrice": "合計金額",
    "addCartMessage": "ショッピングカートに追加されました",
    "addCartMessageFaild": "商品はすでにショッピング カートに入っています。",
    "myAccount": "私のqアカウント",
    "buyHistory": "購入記録",
    "wishlist": "お気に入りの商品",
    "trackOrder": "注文",
    "account": "アカウント：",
    "sellerZone": "商圏",
    "beSeller": "商人になる",
    "sellerPanelLogin": "加盟店ログイン",
    "footTip": "© Copyright {name} Ltd 2024",
    "footTips": "{name} Limited は、信用ブローカー (713206) として Financial Conduct Authority によって認可および規制されており、貸し手である Home Retail Group CardServices Limited を {name} Financial Services として独占的に扱っています。 {name} Financial Services は、Financial Conduct Authority によってクレジットを提供することを承認および規制されています (716148)。 ホーム リテール GroupCard Services Limited は、英国 (04007072) Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom で登録されています。 MK9 2NW.",
    "item": "記事",
    "checkout": "注文する",
    "productDescription": "製品説明",
    "userEvaluation": "ユーザーレビュー",
    "AllProducts": "すべての製品",
    "followers": "従う",
    "sales": "販売量",
    "visitStore": "ストアにアクセス",
    "authentic": "100%本物",
    "dayReturns7": "7日返品",
    "shippingDiscounts": "貨物割引",
    "safePayment": "安全なお支払い",
    "followed": "フォローした",
    "dashboard": "インストルメント・パネル",
    "myOrder": "私の注文",
    "setUp": "設定",
    "successTips": "成功",
    "copySuccess": "レプリケーションが成功しました",
    "balance": "残高(USDT)",
    "sort": "タイプ",
    "commodity": "製品",
    "browse": "販売量",
    "recharge": "リチャージ",
    "commodityCollection": "製品コレクション",
    "withdraw": "現金引き出し",
    "defaultAddress": "デフォルトの住所",
    "addNewAddress": "新しいアドレスを追加",
    "withdrawRecord": "出金記録",
    "serialNumber": "注文番号。",
    "time": "時間",
    "amount": "額",
    "processing": "処理中",
    "fail": "失敗",
    "blockchainNetwork": "ブロックチェーン ネットワーク",
    "records": "記録",
    "withdrawAddress": "現金引き出しアドレス",
    "withdrawInputTips": "出金先住所を入力してください",
    "copy": "レプリケーション",
    "enterTips": "入ってください",
    "actualAccount": "実際のアカウント",
    "handlingFee": "サービス料",
    "confirm": "領収書の確認",
    "previous": "一つ前の手順",
    "pleaseEnterAddress": "住所を入力してください",
    "pleaseEnterQuantity": "数量を入力してください",
    "withdrawSuccess": "注文は正常に送信されました",
    "saveQr": "QRコードを保存",
    "pleaseEnterAmount": "チャージ金額を入力してください",
    "expectedArrival": "到着予定",
    "currentRate": "現在の為替レート",
    "uploadTips": "支払証明（支払詳細のスクリーンショットをアップロード）",
    "clickUpload": "クリックしてアップロード",
    "uploadPhoto": "写真をアップロードしてください",
    "rechargeSuccessful": "リチャージ成功",
    "rechargeTips": "再充電プロンプト: 「実際の送金金額を正直に入力してください。そうしないと、システムが承認に失敗し、再充電の進行に影響を与える可能性があります。",
    "rechargeRecord": "充電記録",
    "all": "全て",
    "pending": "支払われる",
    "cancelled": "キャンセル",
    "delivered": "出荷されます",
    "confirmed": "確認済み",
    "receipt": "受信する",
    "harvested": "受け取った",
    "comment": "レビュー予定",
    "refund": "返金/アフターセールス",
    "cancelOrder": "注文をキャンセルする",
    "cancelReason": "キャンセル理由",
    "cancelOrderTitle": "注文キャンセル理由を選択してください",
    "returnOrderTitle": "返品理由を選択してください",
    "refundInstructions": "払い戻しの手順",
    "returnDetailTips": "商品のレビューをお願いします",
    "cancel": "注文をキャンセルする",
    "cancelOrder1": "商品が届かない",
    "cancelOrder2": "好きじゃない、欲しくない",
    "cancelOrder3": "売り手が間違った商品を発送した",
    "cancelOrder4": "偽ブランド",
    "cancelOrder5": "出荷が少ない、出荷を逃した",
    "cancelOrder6": "受け取った商品が破損している",
    "cancelOrder7": "品質に問題がある",
    "cancelOrder8": "販売者と返金の交渉をする",
    "cancelOrder9": "その他の理由",
    "cancelOrderSuccess": "注文は正常にキャンセルされました",
    "returnOrderSuccess": "正常に送信",
    "orderName": "名前",
    "orderEmail": "Eメール",
    "orderAddress": "住所",
    "orderNation": "国",
    "orderState": "スターテス",
    "orderCity": "街",
    "orderPostCode": "郵便番号",
    "orderAmount": "量",
    "orderPrefix": "合計注文",
    "orderFee": "税金",
    "orderSpecification": "仕様",
    "orderCommodity": "製品",
    "orderQuantity": "量",
    "orderUnitprice": "単価",
    "orderFreight": "貨物",
    "orderTax": "税",
    "orderTotal": "合計",
    "PaymentOrder": "支払指図書",
    "Evaluate": "レビュー",
    "CancelOrder": "注文をキャンセルする",
    "RemindShip": "出荷の通知",
    "Refund": "返金",
    "Submitareview": "レビューを送信する",
    "Information": "情報",
    "wrongPassword": "パスワードエラーが 3 回以上発生しました。 明日もう一度お試しください。",
    "Operate": "手術",
    "Item": "アイテム",
    "From": "から",
    "hint": "チップ",
    "CheckDetails": "詳細を見る",
    "Payment": "支払い",
    "Cancel": "キャンセル",
    "refundSuccessfully": "払い戻しが成功しました",
    "pendingPayment": "支払われる",
    "pay": "支払い",
    "LoginPassword": "ログインパスワード",
    "sure": "もちろん",
    "shippingAddress": "受信アドレス",
    "transactionPassword": "取引パスワード",
    "markDefaultAddress": "デフォルトの配送先住所としてマーク",
    "edit": "によって編集",
    "delete": "消去",
    "Opt": "選択する",
    "piece": "個",
    "orderDetails": "注文詳細",
    "shopCollection": "ストアをお気に入りに追加",
    "addAddress": "新しいアドレスを追加",
    "signUp": "登録",
    "loginTips": "すでにアカウントをお持ちですか？",
    "loginIn": "ログイン",
    "mobile": "電話番号",
    '购物车还没有商品': "ショッピングカートに商品がありません",
    '去购物': "ショッピングに行く",
    "modifyAddress": "住所変更",
    "desc": "デフォルトのアドレスとして設定",
    "keep": "維持",
    "onlineService": "オンラインサービス",
    "send": "送信",
    "EsShop": "オンラインストア",
    "desc3": "取引パスワードを入力",
    "desc4": "取引パスワードを入力してください",
    "desc6": "取引パスワードをもう一度入力してください",
    "setUpPayPaw": "取引パスワードの設定",
    "setSuccess": "セットアップ成功",
    "confirmPayPaw": "取引パスワードの確認",
    "paymentSuccessful": "お支払い完了",
    "desc5": "配送先住所が間違っていませんか？ コンタクト",
    "customeService": "オンラインカスタマーサービス",
    "BackHome": "ホームページに戻ります",
    "Checkorder": "表示の順序",
    "ForgotPassword": "パスワードをお忘れですか？",
    "signIn": "ログイン",
    "noAccount": "口座番号がない？",
    "pleaseEnterAccount": "口座番号を入力してください",
    "pleaseEnterPassword": "パスワードを入力してください",
    "password": "パスワード",
    "mobilePhone": "電話番号",
    "pleaseEnterPhoneNumer": "電話番号を設定してください",
    "setPassword": "パスワードを設定してください",
    "noDataFound": "何もデータが見つかりませんでした",
    "searchCountry": "国名と市外局番を入力して検索",
    "pleaseEnterEmail": "メールボックスを設定してください",
    "invitationCode": "招待コード",
    "plaeseEnterInvitaionCode": "招待コードを設定してください",
    "pleaseSetLoginPassword": "ログインパスワードを設定してください",
    "selectDeliveryAddress": "配送先住所を選択",
    "totalOf": "合計",
    "items": "アイテム",
    "orderSummary": "注文の概要",
    "paymentMethod": "支払方法",
    "Balance": "バランス",
    "payPal": "ペイパル",
    "notOpen": "この支払い方法は、お住まいの地域ではまだ利用できません",
    "mastercard": "マスターカード",
    "additional": "追加",
    "handlingfee": "サービス料が必要",
    "goodsNumber": "製品の数量",
    "deliveryFee": "貨物",
    "totalNum": "合計",
    "new": "新しい",
    "oldPassword": "以前のパスワード",
    "pleaseEnterOldPassword": "古いパスワードを入力してください",
    "newPassword": "新しいパスワード",
    "plaseeEnterNewPassword": "新しいパスワードを入力してください",
    "confirmPassword": "パスワードを認証する",
    "plaseeENterConfirmPassword": "確認パスワードを入力してください",
    "twoPawword": "2 つのパスワードが同じではありません",
    "rechargeAddress": "リチャージアドレス",
    "plaseEnterRechargeAddress": "リチャージアドレスを入力してください",
    "userCenter": "パーソナルセンター",
    "merchantSettled": "商人のエントリ",
    "upNew": "新製品リスト",
    "balanceNot": "バランスが足りない。 充電してください。",
    "NoProductSelected": "製品はまだ選択されていません",
    "ShippingAddressNotSet": "配送先住所が設定されていません",
    "consigneeName": "受取人の名前",
    "email": "Eメール：",
    "areaCode": "国際市外局番",
    "phoneNumber": "電話番号",
    "nation": "国",
    "state": "州/州/州",
    "city": "街",
    "postCode": "郵便番号",
    "address": "詳細住所",
    "addAddressOrModifyAddress": "新しい住所を追加する/住所を変更する",
    "setAsTheDefaultAddress": "デフォルトのアドレスとして設定",
    "proceed": "続く",
    "btnSure": "確認",
    "pleaseInput": "入ってください",
    "allProduct": "すべての製品",
    "myCommodityCollection": "お気に入りの商品",
    "myFollowedShops": "店舗をフォローする",
    "mySold": "売却",
    "myPageviews": "閲覧量",
    "myPraiseRate": "良いレビュー率",
    "myUnfollow": "フォローをやめる",
    "inputNum": "数字",
    "inpuEmailErro": "正しいメールアドレスを入力してください",
    "goodsShip": "出荷",
    "goodsShipTips": "商品はご注文後24時間以内に発送いたします。 下記のご注文は物流管理が行き届いている場合、ご注文が遅れる場合がございます。 注文のロジスティクス情報に注意するか、カスタマーサービスに連絡してください。",
    "goodsFreight": "貨物",
    "goodsFreeShipping": "無料",
    "goodsFreightTips1": "1. 越境商品の運賃構成：運賃＝発送手数料＋長距離運賃＋配送料",
    "goodsFreightTips2": "2. 郵便料金の条件が満たされていない場合、貨物は実際の条件に従って請求されます。",
    "goodsFreightTips3": "3. 最終解釈権はプラットフォームに帰属します。",
    "pleaseValidPostCode": "4桁以上で入力してください",
    "pleaseValidEmail": "正しいメールアドレスを入力してください",
    "pleaseValidPhone": "正しい電話番号を入力してください",
    "productAvailable": "この商品は削除されました",
    "validatorMaxNumber": "金額が上限を超えています",
    "validatorRequire": "必須項目を null にすることはできません",
    "validatorPhone": "正しい電話番号を入力してください",
    "validatorEmail": "正しいメール形式を入力してください",
    "validatorPassword": "パスワードは 6 ～ 12 桁の数字または文字で構成されています(特殊文字が含まれています)",
    "validatorSixNumber": "純粋な 6 桁を入力してください",
    "validatorFourMoreNumber": "4 ～ 32 桁の数字または文字の組み合わせを入力してください",
    "validatorIpRule": "不正な IP 形式",
    "validatorChineseAndEnglish": "中国語と英語のみ、入力範囲: 8 ～ 64 文字",
    "collectionSuccess": "お気に入りに追加しました",
    "followedSuccess": "フォロー成功",
    "cancelSuccess": "キャンセルしました",
    "evaluateOrder": "写真で振り返る",
    recommendclass:"おすすめカテゴリー",
    "滑动验证": "スライド認証",
    "evaluateOrderPlaceholder": "製品を確認してください",
    "operationSuccess": "操作は成功しました",
    "confirmReceiveGoods": "商品の受領確認",
    "evaluateOrderSuccess": "レビュー成功",
    "yesterday": "昨日",
    "notLogin": "まだログインしていません。",
    "delAllHistoryRecord": "すべての履歴レコードを削除してもよろしいですか?",
    "or": "また",
    "tipsRemindsText": "出荷が通知された後、マーチャントは通知を受け取ります",
    "tipsRemindsCount": "1 回だけ思い出させることができます。",
    "tipsRemindsMerchant": "マーチャントに通知する",
    "tipsRemindsSuccess": "リマインダーが成功しました",
    "noCartTips": "ショッピングバッグは空です。 ショッピングを開始します。",
    "defaultRate": "システムはデフォルトで好意的なレビューを表示します",
    "prevPage": "前のページ",
    "nextPage": "次のページ",
    "returnApply": "払い戻しのリクエスト",
    "returnReason": "返金理由",
    "returnAmount": "返品金額",
    "returnRemark": "返品手順",
    order: {
        cancel: "注文をキャンセルする",
        payment: "今払う",
        remind: "出荷の通知",
        return: "商品返金のお願い",
        evaluate: "今すぐレビュー",
        logistics: "ロジスティクスを見る",
        noRefund: "未払い",
        refunding: "払い戻し中",
        refundSuccess: "払い戻しが成功しました",
        refundFail: "払い戻しに失敗しました",
        confirm: "領収書の確認",
        expressCompany: '配送会社',
        trackingNo: '追跡番号',
        noOrderShipping: '物流情報がありません',
        noTransitSteps: '追跡情報がありません',
        logisticsLoadFail: '物流情報の取得に失敗しました。しばらくしてから再試行してください。',
    },
    "remindTitle": "出荷の通知",
    "remindContent": "出荷のリマインダーが送信されると、マーチャントはリマインダーを受け取ります。 1 回だけ思い出させることができます。",
    "remindSuccess": "リマインダーが成功しました",
    "remindRepeat": "この順番を思い出しました。",
    "noComments": "現在レビューはありません",
    "storeSeach": "このストアで商品を探す",
    "storeSeachTips1": "あなたのために見つけました",
    "storeSeachTips2": "関連店舗が見つかりました",
    "storeSeachTips3": "家",
    "creditTit": "クレジットサービス",
    "getCoupons": "より多くのクーポンを入手",
    "yourEmail": "あなたのメールアドレス",
    "subscription": "サブスクリプション",
    "paymethods": "支払方法",
    "footdec": "{name}Shop グローバル サイトのユーザーは、世界 {num} か国から来ており、決済には {coin} を使用しています。 {coin} は、国際手数料や待ち時間なしで、世界中で即時かつ低コストの取引を可能にするボーダレス取引です。",
    "custService": "顧客サービス",
    "helpLine": "オンラインカスタマーサービス",
    "contactUs": "お問い合わせ",
    "partner": "協力業者",
    "客户端下载":
        "クライアント ダウンロード",
    "提现方式": "出金方法",
    "buyRules": "バイヤーのルール",
    "sellerRules": "売り手の方針",
    "returnsAndEx": "返品と交換",
    "servicePolicy": "サービスポリシー",
    "returnPolicy": "返品規則",
    "user_Center": "ユーザーセンター",
    "userReg": "ユーザー登録",
    "orderTrack": "注文クエリ",
    "purchageHistory": "購入履歴",
    "myPurse": "私の財布",
    "aboutUs": "私たちに関しては",
    "Recruitment": "有能な人材を待つ",
    "news": "ニュース情報",
    "stateMent": "現代の奴隷制に関する声明",
    "binance": "バイナンス",
    "huobi": "フォビ",
    "okx": "わかりました",
    "metaMask": "メタマスク",
    "homeBannertips1": "商人になる",
    "homeBannertips2": "合計手数料",
    "homeBannertips3": "最大。",
    "homeBannerbtn": "今すぐ参加",
    "homeDownloadtips1": "越境EC卸モール",
    "homeDownloadtips2": "ブランド特典",
    "homeDownloadtips3": "ノンストップ割引",
    "homeDownloadtips4": "アンドロイド ダウンロード",
    "homeDownloadtips5": "アップルのダウンロード",
    "homeDownloadtips6": "QRコードをスキャンしてアプリをダウンロード",
    "homeIconTips1": "100%本物",
    "homeIconTips2": "7日返品",
    "homeIconTips3": "貨物割引",
    "homeIconTips4": "安全なお支払い",
    "headerSearchTips": "キーワードを入力して検索してください",
    "collAccount": "貸出形態",
    "mine": "私の。",
    "creditText1": "お金を借りる時の悩みをスタートアップローンで解決",
    "creditText2": "スタートアップローンおよび資本回転サービスの提供",
    "creditWorry": "安心のローン",
    "creditQuota": "柔軟な制限",
    "creditQuotaINFO": "100,000 ～ 30,000,000 の柔軟な制限と制限なし、最長 1 年間の融資期間。",
    "quickLoan": "クイックローン",
    "creditReview": "審査は最短1時間で通過、審査を通過すれば即日融資。",
    "safe": "安全で安心",
    "safeInfo": "これは実際には個人的な問題であるため、住宅ローン、預金、コールバックはありません。",
    "about": "私たちに関しては",
    "aboutText1": "私たちは、「お客様第一」の経営理念に基づき、お客様の資本回転の問題を解決することを使命として、融資金融サービスに取り組んでいます。 同社は創業以来、多くのクライアントの資本回転の問題を解決するお手伝いをしてきました。",
    "aboutText2": "限度額: 100,000-30,000,000、低金利の柔軟な返済方法、初期費用なし、オンライン ローン、確認のための電話なし、機密情報、および即日融資。",
    "contactUs1": "レベルメイトからお金を借りたくない場合は、お問い合わせください。",
    "committed": "起業家ローンサービスにコミット",
    "financial": "経済的な懸念に対処する",
    "partnersTit": "パートナー オンライン レンディング プラットフォーム",
    "application": "ローン申し込み",
    "applicant": "申請者",
    "actualName": "本名",
    "yourName": "名前を入力してください",
    "term": "貸出期間",
    "applicationAmount": "請求金額",
    "rates": "ローン金利",
    "loanMethod": "貸出形態",
    "accountB": "勘定残高",
    "countryOf": "国籍",
    "myloan": "私のローン",
    "applyLoan": "ローンを申し込む",
    "loaned": "貸与",
    "interest": "経過利息",
    "esRepayment": "返済予定額",
    "loanHistory": "貸出記録",
    "applicantDate": "出願日",
    "repayment": "返済",
    "cycle": "返済サイクル",
    "fixedRate": "固定金利",
    "successLoan": "ローンが成功しました",
    "Reapply": "再申請",
    "borrow": "ローンに失敗しました",
    "applicantIn": "申請中",
    "repaid": "返済",
    "overdue": "延滞",
    "estirepay": "返済予定額",
    "loanDays": "貸与日数",
    "reAmount": "返済額",
    "repay": "返済モード",
    "entRepay": "返済の確認",
    "foryourmoney": "資金が不足している場合、お金を借りる場所が見つからない場合、または友達からお金を借りるのが恥ずかしい場合は、お問い合わせください。 私たちはいつでもあなたの疑問に答えるために、プロフェッショナルなサービスの全プロセスを持っています. 私たちの目標は、お客様が迅速かつ自信を持って使用できるように、各ローンを透明にすることです。",
    "onlineApplin": "オンラインで申し込む",
    "businessloan": "スタートアップローンの申し込み",
    "selectCountry": "国籍を選択してください",
    "selectPeriod": "期間を選択してください",
    "passPortImg": "ID番号/パスポート番号",
    "uploadId": "証明書の写真/パスポートのアップロード",
    "readAndAgree": "私は読み、同意します",
    "loanAgree": "貸借同意書",
    "submitApplica": "申請書の提出",
    "photoExample": "撮影例",
    "discounted": "割引商品",
    "days": "日",
    "privacyPolicy": "プライバシーポリシー",
    "delivery": "配送と集荷",
    "checkAgreement": "同意書にチェックを入れてください！",
    "businessPhone": "ビジネス用電話機",
    "businessEmail": "社内メール",
    "最多上传9张图片": "最多9枚の写真をアップロードしてください",
    "账号注销": "アカウントの登録解除",
    "确定注销": "登録解除を確認します",
    "您的账号": "あなたのアカウント",
    "为什么要离开": "なぜ離れるのですか",
    "您还有余额,不能注销账号": "残高があります。アカウントを登録解除できません!",
    "请输入注销理由": "登録解除の理由を入力してください",
    "您确认要注销吗?": "あなたは登録解除を確認しますか？",
    "我再考虑下": "もう一度考えてみます",
    "同意注销": "同意します",
    "注销成功": "登録解除に成功しました",
    "暂无店铺": "店舗がありません",
    "App下载(买家端)": "アプリのダウンロード（買い手）",
    "App下载(卖家端)": "アプリのダウンロード（売り手）",
    "请选择": "選択してください",
    "绑定成功": "バインドに成功しました",
    "加值": "加算",
    "平台人工发起退款": "プラットフォーム人工発起返金",
    "银行卡": "銀行カード",
    "联系商家": "商人に連絡する",
    "提领": "引き出し",
    "最多包含10位小数": "最大10桁の小数を含める",
    "企业电话": "企業電話",
    "职业机会": "職場の機会",
    "提款地址绑定": "引き出しアドレスのバインド",
    "仅能绑定一个收款地址!": "受け取りアドレスは1つだけバインドできます！",
    "长时间未付款，系统自动取消订单": "長時間支払われないと、システムは注文を自動的にキャンセルします",
    "加密货币": "暗号通貨",
    "银行卡": "銀行カード",
    '参数缺失': "パラメータが不足しています",
    '充值数量必填': "チャージ数量は必須です",
    "充值币种": "チャージ通貨",
    "充值金额": "チャージ金額",
    "充值金额不得小于": "チャージ金額は以下にすることはできません",
    "充值金额不得大于": "チャージ金額は以下にすることはできません",
    "请先选择币种": "まず通貨を選択してください",
    "开户行": "開設銀行",
    "请输入开户行名称": "開設銀行名を入力してください",
    "银行卡号": "銀行カード番号",
    "请输入银行卡号": "銀行カード番号を入力してください",
    "点击去支付": "クリックして支払いに行く",
    "企业证明": "企業証明",
    "当前余额": "現在の残高",
    "备注": "備考",
    footTipTikTok:'BizSpring モール ©️2024 著作権',
    TikTokFoot:'BizSpring は、BizSpring とアジア最大の卸売商社Alibabaが協力して設立したグローバルショートビデオソーシャルプラットフォームです。 これはグローバルな電子商取引プラットフォームであり、カナダのトロント、ロサンゼルス、日本の千葉にある世界 3 か所に自社運営のスマート ウェアハウスを持っています。 アプリ内で販売されている商品には、日本、韓国、中国などアジア各国の人気商品が含まれています。 現在、その総数は50,000件を超え、急速に成長を続けています。',
    "cancelInfo":"警告します！ アカウントをキャンセルする際は十分にご注意ください.アカウントを使用しなくなった場合は、[キャンセルに同意する]をクリックしてください.キャンセル後、数日以内に登録できない場合があります."
,
  "getCouponSuccess": "クーポン取得完了",
  "liveRooms": "ライブルーム",
  "liveStreaming": "ライブ中",
  "notStarted": "未開始",
  "finished": "終了",
  "myPoints": "マイポイント",
  "searchGoods": "商品を検索",
  "points": "ポイント",
  "point": "ポイント",
  "stock": "在庫",
  "spec": "仕様",
  "exchangeNow": "今すぐ交換",
  "currentPoint": "マイポイント",
  "pointNotEnough": "ポイントが不足しています"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "日语(ja)",
    "addImageHint": "（画像を追加してください）",
    "deleteNode": "削除",
    "topPos": "トップ {n}",
    "col": "列 {n}",
    "pos": "位置 {n}",
    "decoType_container": "コンテナ",
    "decoType_title": "タイトルテキスト",
    "decoType_richText": "リッチテキスト",
    "decoType_notice": "お知らせ",
    "decoType_blank": "スペーサー",
    "decoType_banner": "カルーセル",
    "decoType_imageSingle": "単一画像",
    "decoType_imageMulti": "複数画像",
    "decoType_video": "動画",
    "decoType_goodsRecommend": "商品おすすめ",
    "decoType_goodsSelection": "商品セレクション",
    "decoType_seckill": "タイムセール",
    "decoType_groupBuy": "共同購入",
    "decoType_coupon": "クーポン",
    "decoType_searchNav": "検索ナビ",
    "decoType_search": "検索ボックス",
    "decoType_searchBox": "検索ボックス",
    "decoType_categoryNav": "カテゴリーナビ",
    "decoType_goodsCategory": "商品カテゴリー",
    "decoType_navIconRow": "ナビアイコン",
    "decoType_imageScroll": "画像スクロール",
    "decoType_pageBanner": "ページバナー",
    "decoType_tabs": "タブ",
    "decoType_brand": "ブランド",
    "decoType_storeRecommend": "店舗おすすめ",
    "decoType_hotSelection": "人気セレクション",
    "decoType_footerLinkGroup": "フッターリンク",
    "decoType_partnerLogoRow": "パートナー",
    "decoType_icpInfo": "ICP情報",
    "decoType_topNavMenu": "トップナビ",
    "decoType_logoBlock": "ロゴ",
    "decoType_langSwitcher": "言語",
    "decoType_currencySwitcher": "通貨",
    "decoType_loginBlock": "ログイン",
    "decoType_cartIcon": "カート",
    "decoType_messageIcon": "メッセージ",
    "seckillPrice": "セール価格",
    "seckillTag": "タイムセール",
    "seckillCountdown": "終了まで",
    "seckillNotStarted": "まもなく開始",
    "seckillRushing": "セール中",
    "seckillWillStart": "まもなく開始",
    "seckillBuy": "今すぐ購入（セール）",
    "groupPrice": "共同購入価格",
    "groupRequiredNum": "人で成立",
    "noGroupBuy": "単品購入",
    "groupRule1": "1. 商品を選ぶ",
    "groupRule2": "2. 共同購入を開始",
    "groupRule3": "3. 成立後に発送",
    "marketingMoneyOff": "値引き",
    "marketingFreeShipping": "送料無料",
    "marketingGift": "プレゼント",
    "marketingCoupon": "クーポン",
    "marketingGroup": "共同購入",
    "marketingSeckill": "タイムセール",
    "marketingExpired": "キャンペーン終了",
    "marketingNotActive": "キャンペーン未開催",
    "alreadyGotCoupon": "取得済み",
    "couponReceived": "受け取り済み",
    "hotSearch": "人気の検索："
}